<template>
<div>   
    <!-- 纯图片列表 -->
    <el-col   :span="23"    class="affix_wrap"  >
        <div class="affix_box"  v-for="(item,index) of affixfileList"   :key="item.id">
            <div class="up">  
                
 
                <!-- <img   :src="item.link" :alt="item.fileName" @click="CheckFile(item)"> -->

                <el-image 
                    :initial-index="index"
                    fit='contain'
                    @click="getSrcList"
                    :src="item.link" 
                    
                    :preview-src-list="srcList">
                </el-image>
                <!-- +'?x-oss-process=chat_img' -->
         


            </div>
            <div class="down">{{item.fileName}}  </div>

            
        </div>

            
    </el-col>


    <el-dialog :visible.sync="dialogVisible"  custom-class="detail_dia"    top='5vh' >
        <div style="width:100%; text-align:center">
            <img   style="height:70vh;margin:auto; " :src="dialogImageUrl" alt=""  >

        </div>
        <!-- <img   style="height:70vh;margin:auto " :src="dialogImageUrl" alt=""  > -->
    </el-dialog>
</div>
    
	 
	
</template>

<script>
 

	export default {
    name: 'affix_box',
    props: {
            // detail_visible:Boolean,
            // current_form:Object,
            affixfileList:Array,
        },
        components: { 
 
 
            
         
        },
        data() {
			return { 
            //    detail_visible:true ,
                // detail_visible:false,
                screenHeight:window.innerHeight || '',
                dialogVisible:false,
                dialogImageUrl:'',
                srcList:[],
           
			}
        },
        mounted(){
        //    let arr=[]
        //     for(let p of this.affixfileList){
        //         arr.push(p.link)
        //     }
        //     this.srcList=arr
           
        },
        methods: {
            getSrcList(){
                let arr=[]
                for(let p of this.affixfileList){
                    arr.push(p.link)
                }
                this.srcList=arr

            },
            CheckFile(item){

                console.log('check file item:',item)
               
                this.dialogImageUrl = item.link ;
                this.dialogVisible = true;

                // window.open(item.tempLink)


            },

            OpenFile(tempLink){
                console.log('OpenFile--------')
                window.open(tempLink, "_blank")

            },
            isImg(filename){
                //  return [
                //     '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'].
                //     indexOf(ext.toLowerCase()) !== -1;


                return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(filename);


            }


        }
	}
</script>

<style >
 .detail_dia{
    /* overflow-y: scroll; */
    height: 85vh;
    border-radius: 5px;
 }


.affix_wrap{
    padding: 5px;
    display:flex; 
    flex-direction:row;
    flex-wrap: wrap;
    border:1px dashed #969595;
    width:100%;
    min-height: 180px;
}

.affix_box{
    /* background-color: #fbfdff; */
    /* border: 1px solid #c0ccda; */
    /* border: 1px solid #1557a1; */

    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    /* height: 148px; */
    height: 178px;
    /* line-height: 146px; */
    /* vertical-align: top; */
    margin-left: 10px;

    cursor: pointer;
    display: flex;
    flex-direction: column;

}

.affix_box .up{
    height: 148px;
    width: 100;
}

.affix_box .down{
    height: 30px;
    width: 100%;
    /* border: 1px solid #c0ccda; */
    line-height: 30px;
    font-size:10px;
    overflow: hidden;
    text-align: center;
}

.affix_box img {
    width:100% ;
    /* max-height: 100%; */
}

.affix_box .el-image{
    /* width:auto;  */
    height: 98%;
    /* max-height: 100%; */
    /* border: 1px solid #2172ce;  */
}


.el-image__placeholder {
  background: url('../../assets/images/loading.png') no-repeat 50% 50% !important;
  background-size: 50% !important;
}


</style>
